import { Tooltip } from "@mui/material";
import React from "react";
import styled, { css } from "styled-components";
import useIsTruncated from "./useIsTruncated";

const singleLine = css`
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const multiLine = (lines: number) => css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
`;

const Clamped = styled.span<{ $lines: number }>`
  width: 100%;
  overflow: hidden;
  ${({ $lines }) => ($lines === 1 ? singleLine : multiLine($lines))}
`;

type TruncatedTextProps = {
  children: string;
  className?: string;
  lines?: number;
};

function TruncatedText({
  children,
  className = "",
  lines = 1,
}: TruncatedTextProps) {
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>(children);

  return (
    <Tooltip title={isTruncated ? children : ""}>
      <Clamped
        ref={ref}
        className={className}
        $lines={lines}
        tabIndex={isTruncated ? 0 : undefined}
      >
        {children}
      </Clamped>
    </Tooltip>
  );
}

export default TruncatedText;
